// @flow
import TextInput from './TextInput';

export default TextInput;
export type { Props as TextInputProps } from './TextInput';
